/* istanbul ignore file */
export { AccordionComponentsModule } from './accordion-components.module';
export { AccordionComponent } from './accordion/accordion.component';
export * from './accordion/accordion-animation';
